<template>
  <div class="fill_form mt20 m0 mb30 clearfix" key="retireEdit">
    <ul class="fr operation_list">
      <li class="fl" @click="save">保存</li>
      <li class="fl" @click="cancel">取消</li>
    </ul>
    <!--标题-->
    <p class="tip_bar" v-if="$route.query.isFromWorker=='true'"><span class="question_logo">?</span>完善资料并保存后，即可将此在职人员转为退休人员
    </p>
    <vue-form :state="formstate">
      <h3 class="form_title clearfix"><span>| </span>基本信息
      </h3>

      <!-- 标题 end-->
      <div class="fill_group_row clearfix fl w_half">

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>姓名</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input time_icon" name="username" required v-model="params.user.username"
                   type="text"/>
            <field-messages name="username" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">姓名不能为空</div>
            </field-messages>
          </div>
        </validate>

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>性别</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select time_icon" name="sex" required v-model="params.user.sex">
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
            <field-messages name="sex" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">姓别不能为空</div>
            </field-messages>
          </div>
        </validate>

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>参加工作日期</label>
          <div class="form_control w_auto ">
            <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model="params.user.work_time" name="workDate"></vue-datepicker-local>-->
            <input class="i_w300 form_input" placeholder="xxxx/xx/xx" required name="workDate" type="text"
                   v-model="params.user.work_time" @blur="changeWorkTime()"/>
            <field-messages name="workDate" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">参加工作日期不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>工作单位</label>
          <div class="form_control w_auto ">
            <select class="i_w300 form_select" name="companyName" type="text" required v-model="params.user.company_id"
                    pattern="^[1-9]\d*$">
              <option value=0>请选择单位</option>
              <option :value="item.id" v-for="(item,index) in companyData">{{ item.company_name }}</option>
            </select>
            <field-messages name="companyName" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">工作单位不能为空</div>
              <div slot="pattern" class="errorMessage">工作单位不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>联系手机</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" name="mobile" required pattern="^[1][0-9]{10}$" type="text"
                   v-model="params.user.mobile"/>
            <field-messages name="mobile" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">联系手机不能为空</div>
              <div slot="pattern" class="errorMessage">请填写正确的手机号</div>
            </field-messages>
          </div>
        </validate>
      </div>
      <div class="fill_group_row clearfix fr w_half">

        <!--<validate tag="div" class="form_group clearfix">-->
        <!--<label class="control_label "><em>*</em>居民身份证</label>-->
        <!--<div class="form_control w_auto ">-->
        <!--<input class="i_w300 form_input time_icon" name="idCard" @blur="takeBirthday" pattern="^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$" required type="text" v-model="params.user.idcard"/>-->
        <!--<field-messages name="idCard" show="$dirty || $touched || $submitted">-->
        <!--<div slot="required" class="errorMessage">居民身份证不能为空</div>-->
        <!--<div slot="pattern" class="errorMessage">请输入正确的居民身份证号</div>-->
        <!--</field-messages>-->
        <!--</div>-->
        <!--</validate>-->

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>民族</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" name="mobile" required type="text" v-model="params.user.nation"/>
            <field-messages name="mobile" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">民族不能为空</div>
            </field-messages>
          </div>
        </validate>

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>社会保障号</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" name="socialSecurityAccount" required
                   v-model="params.user.social_security_account" type="text"/>
            <field-messages name="socialSecurityAccount" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">社会保障号不能为空</div>
            </field-messages>
          </div>
        </validate>

        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>出生日期</label>
          <div class="form_control w_auto ">
            <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model='params.user.birthday' name="birthday"></vue-datepicker-local>-->
            <input class="i_w300 form_input" placeholder="xxxx/xx/xx" required name="birthday" type="text"
                   v-model="params.user.birthday"/>
            <field-messages name="birthday" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">出生日期不能为空</div>
            </field-messages>
          </div>
        </validate>
        <validate tag="div" class="form_group clearfix">
          <label class="control_label "><em>*</em>邮政编码</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" type="text" name="postalCode" required pattern="^[1-9][0-9]{5}$"
                   v-model='params.user.postal_code'/>
            <field-messages name="postalCode" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">邮政编码不能为空</div>
              <div slot="pattern" class="errorMessage">请输入正确的邮政编码</div>
            </field-messages>
          </div>
        </validate>
        <div class="form_group clearfix">
          <label class="control_label ">固定电话</label>
          <div class="form_control w_auto ">
            <input class="i_w300 form_input" type="text" v-model='params.user.telephone'/>
          </div>
        </div>
        <!--<validate tag="div" class="form_group clearfix" style="visibility: hidden" >-->
        <!--<label class="control_label "><em>*</em>工作单位</label>-->
        <!--<div class="form_control w_auto ">-->
        <!--<input class="i_w300 form_input" name="company_name" required type="text" v-model="params.user.work_unit_name" />-->
        <!--<field-messages name="company_name" show="$dirty || $touched || $submitted">-->
        <!--<div slot="required" class="errorMessage">工作单位不能为空</div>-->
        <!--</field-messages>-->
        <!--</div>-->
        <!--</validate>-->
      </div>
      <div class="fill_group_row clearfix">
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>户籍所在地</label>
          <div class="form_control w_auto">

            <div class="flex fl" style="position: relative;">
              <div class="w_375">
                <validate tag="div" class="fl">
                  <select class="form_select s_w120" name="domicileProvince" required
                          v-model='params.user.domicile_province'>
                    <option value="">省</option>
                    <option v-for="(item,index) in areas.allArr" :value="index">
                      {{ item.name }}
                    </option>
                  </select>
                  <field-messages name="domicileProvince" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">省不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="domicileCity" required v-model='params.user.domicile_city'>
                    <option value="">市</option>
                    <option v-for="(item,index) in areas.domicileCities" :value="index">{{ item.name }}</option>
                  </select>
                  <field-messages name="domicileCity" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">市不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="domicileDistrict" required
                          v-model='params.user.domicile_district'>
                    <option value="">区</option>
                    <option v-for="(item,index) in areas.domicileDistrict" :value="index">{{ item.name }}</option>
                  </select>
                  <field-messages name="domicileDistrict" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">区不能为空</div>
                  </field-messages>
                </validate>
              </div>
              <validate tag="div" class="auto_flex" style="position: relative;">
                <input class=" form_input time_icon w100" required type="text" name="domicileDetail"
                       v-model='params.user.domicile_detail'/>
                <field-messages name="domicileDetail" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">户籍所在地详情不能为空</div>
                </field-messages>
              </validate>
            </div>

          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>通讯地址</label>
          <div class="form_control w_auto">

            <div class="flex fl" style="position: relative;">
              <div class="w_375">
                <validate tag="div" class="fl">
                  <select class="form_select s_w120" name="address_province" required
                          v-model="params.user.address_province">
                    <option value="">省</option>
                    <option v-for="(item,index) in areas.allArr" :value="index">
                      {{ item.name }}
                    </option>
                  </select>
                  <field-messages name="address_province" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">省不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="address_city" required v-model="params.user.address_city">
                    <option value="">市</option>
                    <option v-for="(item,index) in areas.addressCities" :value="index">{{ item.name }}</option>
                  </select>
                  <field-messages name="address_city" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">市不能为空</div>
                  </field-messages>
                </validate>
                <validate tag="div" class="fl" style="position: relative; margin-left: 4px;">
                  <select class="form_select s_w120" name="address_district" required
                          v-model='params.user.address_district'>
                    <option value="">区</option>
                    <option v-for="(item,index) in areas.addressDistrict" :value="index">{{ item.name }}</option>
                  </select>
                  <field-messages name="address_district" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">区不能为空</div>
                  </field-messages>
                </validate>
              </div>
              <validate tag="div" class="auto_flex" style="position: relative;">
                <input class=" form_input time_icon w100" required type="text" name="address_detail"
                       v-model="params.user.address_detail"/>
                <field-messages name="address_detail" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">通讯地址详情不能为空</div>
                </field-messages>
              </validate>

            </div>

          </div>
        </div>
      </div>


      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>2014年9月30日前人事信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>改革时人员类别</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" @change="getPositionInfo(params.special.type,'special')"
                      name="specialType"
                      required v-model="params.special.type" pattern="^[1-9]\d*$">
                <option value=0>请选择</option>
                <option v-for="(value,index) in personnelType" :value="index">{{ value }}</option>
              </select>
              <field-messages name="specialType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">改革时人员类别不能为空</div>
                <div slot="pattern" class="errorMessage">改革时人员类别不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>2014年9月岗位级别</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" v-model="params.special.position_id" name="dutiesType"
                      required pattern="^[1-9]\d*$">
                <option value='0'>请选择</option>
                <option :value="index" v-for="(value,index) in positionInfo1">{{ value }}</option>
              </select>
              <field-messages name="dutiesType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">2014年9月岗位级别不能为空</div>
                <div slot="pattern" class="errorMessage">2014年9月岗位级别不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>改革时基本工资</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input time_icon" required name="changeBasicWage"
                     v-model="params.special.basic_wage" type="number"/>元
              <field-messages name="changeBasicWage" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">改革时基本工资不能为空</div>
              </field-messages>
            </div>
          </validate>
        </div>
        <div class="fill_group_row clearfix fr w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>改革时薪级</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input time_icon" required name="basicWage" v-model="params.special.salary_level"
                     type="number" pattern="^[1-9]\d*$"/>
              <field-messages name="basicWage" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">改革时薪级不能为空</div>
                <div slot="pattern" class="errorMessage">请填写非零开头的数字</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>改革时退休补贴</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.special.retirement_allowance" name="sRetirementAllowance"
                     type="number" required/>元
              <field-messages name="sRetirementAllowance" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">改革时退休补贴不能为空</div>
              </field-messages>
            </div>
          </validate>

        </div>
      </div>

      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>退休信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>变更类型</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" name="changeType" required
                      v-model="params.retirement.change_type" required pattern="^[1-9]\d*$">
                <option value="1">在职转退休</option>
              </select>
              <field-messages name="changeType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">变更类型不能为空</div>
                <div slot="pattern" class="errorMessage">变更类型不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>退休类型</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" name="retirementsType" required
                      v-model="params.retirement.retirement_type" pattern="^[1-9]\d*$">
                <option value='0'>请选择</option>
                <option v-for="(value,index) in retiredType" :value="index">{{ value }}</option>
              </select>
              <field-messages name="retirementsType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休类型不能为空</div>
                <div slot="pattern" class="errorMessage">退休类型不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>退休时人员类别</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" name="retirementsPersonType"
                      @change="getPositionInfo(params.retirement.rank,'retirement')" required
                      v-model="params.retirement.rank" pattern="^[1-9]\d*$">
                <option value=0>请选择</option>
                <option value="1">事业单位专业技术人员</option>
                <option value="2">事业单位管理人员</option>
                <option value="3">事业单位工人</option>
              </select>
              <field-messages name="retirementsPersonType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休时人员类别不能为空</div>
                <div slot="pattern" class="errorMessage">退休时人员类别不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>退休日期</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model="params.retirement.date" name="retirementDate"></vue-datepicker-local>-->
              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" required name="retirementDate" type="text"
                     v-model="params.retirement.date" @blur="changeRetiret()"/>
              <field-messages name="retirementDate" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休日期不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>待遇开始日期</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model="params.retirement.treatment_start_time" name="treatmentStartTime"></vue-datepicker-local>-->
              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" name="treatmentStartTime" required type="text"
                     v-model="params.retirement.treatment_start_time" @blur="changeReissue()"/>
              <field-messages name="treatmentStartTime" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">待遇开始日期不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>补发开始日期</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out"  required v-model="params.retirement.reissue_start_time" name="treatmentStartTime"></vue-datepicker-local>-->
              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" name="treatmentStartTime" required type="text"
                     v-model="params.retirement.reissue_start_time"/>
              <field-messages name="reissueStartTime" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">补发开始日期不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>国办发【2015】3号文增加的退休费</label>
            <div class="form_control w_auto ">
              <input class=" form_input time_icon i_w300" required name="extraAllowance"
                     v-model="params.special.extra_allowance" type="number"/>元
              <field-messages name="extraAllowance" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">增加退休费不能为空</div>
              </field-messages>
            </div>
          </validate>
        </div>
        <div class="fill_group_row clearfix fr w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>退休岗位级别</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" v-model="params.retirement.position_id" name="positionId"
                      required pattern="^[1-9]\d*$">
                <option value=0>请选择</option>
                <option :value="index" v-for="(value,index) in positionInfo2">{{ value }}</option>

              </select>
              <field-messages name="positionId" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休岗位级别不能为空</div>
                <div slot="pattern" class="errorMessage">退休岗位级别不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>退休时薪级</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input time_icon" required name="retireBasicWage"
                     v-model="params.retirement.salary_level" type="number" pattern="^[1-9]\d*$"/>
              <field-messages name="retireBasicWage" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休时薪级不能为空</div>
                <div slot="pattern" class="errorMessage">请填写非零开头的数字</div>
              </field-messages>
            </div>
          </validate>
          <div class="form_group clearfix">
            <label class="control_label "><em>*</em>视同缴费年限</label>
            <div class="form_control w_auto">
              <validate tag="div" class="fl" style="position: relative;">
                <input class="form_input s_w120" name="paymentYears" type="number" required
                       v-model="params.retirement.payment_years" @blur="getTotal()">
                年
                <field-messages name="paymentYears" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">视同缴费年限不能为空</div>
                </field-messages>
              </validate>
              <validate tag="div" class="fl ml20" style="position: relative; margin-left: 4px;">
                <input class="form_input s_w120" name="paymentMonths" type="number" required
                       v-model="params.retirement.payment_months" @blur="getTotal()">
                月
                <field-messages name="paymentMonths" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">视同缴费月数不能为空</div>
                </field-messages>
              </validate>
            </div>
          </div>
          <div class="form_group clearfix">
            <label class="control_label "><em>*</em>实际缴费年限</label>
            <div class="form_control w_auto">
              <validate tag="div" class="fl" style="position: relative;">
                <input class="form_input s_w120" name="actualPaymentYears" type="number" required
                       v-model="params.retirement.actual_payment_years" @blur="getTotal()">
                年
                <field-messages name="actualPaymentYears" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">实际缴费年限不能为空</div>
                </field-messages>
              </validate>
              <validate tag="div" class="fl ml20" style="position: relative; margin-left: 4px;">
                <input class="form_input s_w120" name="actualPaymentMonths" type="number" required
                       v-model="params.retirement.actual_payment_months" @blur="getTotal()">
                月
                <field-messages name="actualPaymentMonths" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">实际缴费月数不能为空</div>
                </field-messages>
              </validate>
            </div>
          </div>
          <div class="form_group clearfix">
            <label class="control_label "><em>*</em>累计缴费年限</label>
            <div class="form_control w_auto">
              <validate tag="div" class="fl" style="position: relative;">
                <input class="form_input s_w120" name="accumulatedPaymentYears" type="number" required
                       v-model="params.retirement.accumulated_payment_years">
                年
                <field-messages name="accumulatedPaymentYears" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">累计缴费年限不能为空</div>
                </field-messages>
              </validate>
              <validate tag="div" class="fl ml20" style="position: relative; margin-left: 4px;">
                <input class="form_input s_w120" name="accumulatedPaymentMonths" type="number" required
                       v-model="params.retirement.accumulated_payment_months">
                月
                <field-messages name="accumulatedPaymentMonths" show="$dirty || $touched || $submitted">
                  <div slot="required" class="errorMessage">累计缴费月数不能为空</div>
                </field-messages>
              </validate>
            </div>
          </div>
          <div class="form_group clearfix">

            <label class="control_label "><em>*</em>退休补贴</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input time_icon" required name="retireBasic"
                     v-model="params.retirement.retirement_allowance" type="number" pattern="^[1-9]\d*$"/>
              <field-messages name="retireBasic" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休补贴不能为空</div>
                <div slot="pattern" class="errorMessage">请填写非零开头的数字</div>
              </field-messages>
            </div>
          </div>

        </div>
      </div>

      <!--标题-->
      <h3 class="form_title clearfix mb10"><span>| </span>过渡期最后一次职务升降级信息
      </h3>
      <div class="form_group clearfix">
        <label class="control_label " style="width: 154px;padding-right: 8px;">是否有过渡期</label>
        <div class="form_control w_auto ">
          <select class="i_w300 form_select time_icon" @change="changeInterim()" v-model="params.period.transition">
            <option value="0">请选择</option>
            <option value="1">是</option>
            <option value="2">否</option>
          </select>
        </div>
      </div>
      <!--<p class="tip_bar mb20"><span class="question_logo">?</span>如在过渡期内没有职务升降，则填写和退休时同样的信息</p>-->

      <!-- 标题 end-->
      <div class="clearfix" v-show="params.period.interim">
        <div class="fill_group_row clearfix fl w_half">
          <!--<validate class="form_group clearfix">     <em>*</em>-->
          <label class="control_label " style="width: 154px;padding-right: 8px;margin-bottom: 30px">人员类别</label>
          <div class="form_control w_auto " style="margin-bottom: 30px">
            <select class="i_w280 form_select time_icon" name="periodType"
                    @change="getPositionInfo(params.period.type,'period')"
                    v-model="params.period.type" pattern="^[1-9]\d*$">
              <option value=0>请选择</option>
              <option value="1">事业单位专业技术人员</option>
              <option value="2">事业单位管理人员</option>
              <option value="3">事业单位工人</option>
            </select>
            <!--<field-messages name="periodType" show="$dirty || $touched || $submitted">-->
            <!--<div slot="required" class="errorMessage">人员类别不能为空</div>-->
            <!--<div slot="pattern" class="errorMessage">人员类别不能为空</div>-->
            <!--</field-messages>-->
          </div>
          <!--</validate>-->
          <!--<validate tag="div" class="form_group clearfix">  <em>*</em>-->
          <label class="control_label " style="width: 154px;padding-right: 8px;margin-bottom: 30px">最后一次职务升降信息</label>
          <div class="form_control w_auto " style="margin-bottom: 30px">
            <select class="i_w280 form_select time_icon" required v-model="params.period.position_change_last"
                    name="positionChangeLast" pattern="^[1-9]\d*$">
              <option value="0">请选择</option>
              <option :value="index" v-for="(value,index) in positionInfo3">{{ value }}</option>
            </select>
            <!--<field-messages name="positionChangeLast" show="$dirty || $touched || $submitted">-->
            <!--<div slot="required" class="errorMessage">最后一次职务升降信息不能为空</div>-->
            <!--<div slot="pattern" class="errorMessage">最后一次职务升降信息不能为空</div>-->
            <!--</field-messages>-->
          </div>
          <!--</validate>-->
          <!--<validate class="form_group clearfix">  <em>*</em>-->
          <label class="control_label " style="width: 154px;padding-right: 8px;margin-bottom: 30px">升降后职务对应的2014年9月基本工资标准</label>
          <div class="form_control w_auto " style="margin-bottom: 30px">
            <input class="i_w280 form_input time_icon" required v-model="params.period.position_change_basic_wage"
                   name="basicWage1" type="number"/>元
            <!--<field-messages name="basicWage1" show="$dirty || $touched || $submitted">-->
            <!--<div slot="required" class="errorMessage">基本工资标准不能为空</div>-->
            <!--</field-messages>-->
          </div>
          <!--</validate>-->
        </div>
        <div class="fill_group_row clearfix fr w_half">
          <!--<validate tag="div" class="form_group clearfix">  <em>*</em>-->
          <label class="control_label " style="margin-bottom: 30px">职务升降时间</label>
          <div class="form_control w_auto " style="margin-bottom: 30px">
            <!--<vue-datepicker-local class="i_w280 form_input date_picker_out" required v-model="params.period.position_change_time" name="positionChangeTime"></vue-datepicker-local>-->

            <input class="i_w280 form_input" placeholder="xxxx/xx/xx" required name="positionChangeTime" type="text"
                   v-model="params.period.position_change_time"/>
          </div>
          <!--</validate>-->

          <!--<validate tag="div" class="form_group clearfix">-->
          <label class="control_label " style="margin-bottom: 30px">薪级</label>
          <div class="form_control w_auto " style="margin-bottom: 30px">
            <input class="i_w280 form_input time_icon" required name="periodBasicWage"
                   v-model="params.period.salary_level" type="number" pattern="^[1-9]\d*$"/>
          </div>
          <label class="control_label " style="margin-bottom: 30px">退休补贴</label>
          <div class="form_control w_auto " style="margin-bottom: 30px">
            <input class="i_w280 form_input" required v-model="params.period.retirement_allowance"
                   name="retirementAllowance" type="number"/>元
          </div>
        </div>
      </div>

      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>老办法待遇信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <div class="form_group clearfix">
            <label class="control_label ">是否军转干部</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" v-model="params.oldMethod.military_cadres">
                <option value="0">请选择</option>
                <option value="1">是</option>
                <option value="2">否</option>
              </select>
            </div>
          </div>


          <!--<validate   >  <em>*</em>-->
          <div tag="div" class="form_group clearfix" :class="[ turnDry ? 'shiftShow' : 'shiftHide' ]">
            <label class="control_label ">转业时间</label>
            <div class="form_control w_auto ">
              <!--<vue-datepicker-local class="i_w300 form_input date_picker_out" required v-model="params.oldMethod.military_revolution_time" name="militaryRevolutionTime"></vue-datepicker-local>-->

              <input class="i_w300 form_input" placeholder="xxxx/xx/xx" required name="militaryRevolutionTime"
                     type="text" v-model="params.oldMethod.military_revolution_time"/>
            </div>
          </div>
          <div class="form_group clearfix" :class="[ turnDry ? 'shiftShow' : 'shiftHide' ]">

            <label class="control_label ">转业时部队技术等级</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select" name="techRankName" type="text" required
                      v-model="params.oldMethod.military_rank">
                <option value=0>请选择</option>
                <option :value="item.id" v-for="(item,index) in techRank">{{ item.level }}</option>
              </select>
              <field-messages name="techRankName" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">转业时部队技术等级不能为空</div>
                <div slot="pattern" class="errorMessage">转业时部队技术等级不能为空</div>
              </field-messages>
            </div>
          </div>


        </div>
        <div class="fill_group_row clearfix fr w_half">
          <!--<div tag="div" class="form_group clearfix">-->
          <!--<label class="control_label ">老办法养老金</label>-->
          <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input time_icon" v-model="params.oldMethod.old_method_pension" name="oldMethodPension" type="text"/>-->
          <!--</div>-->
          <!--</div>-->
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>计发比例</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input time_icon" required v-model="params.oldMethod.proportion"
                     name="proportion" type="text"/>
              <field-messages name="proportion" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">计发比例不能为空</div>
              </field-messages>
            </div>
          </validate>

          <div class="form_group clearfix" :class="[ turnDry ? 'shiftShow' : 'shiftHide' ]">

            <label class="control_label ">转业时部队职务</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select" name="positionName" type="text" required
                      v-model="params.oldMethod.military_position">
                <option value=0>请选择</option>
                <option :value="item.id" v-for="(item,index) in positionArmy">{{ item.level }}</option>
              </select>
            </div>

          </div>

        </div>
      </div>

      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>新办法待遇信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>退休时人员类别</label>
            <div class="form_control w_auto ">
              <select class="i_w300 form_select time_icon" name="retirementType" required
                      v-model="params.newMethod.retirement_type" pattern="^[1-9]\d*$">
                <option value='0'>请选择</option>
                <option v-for="(value,index) in retiredType" :value="index">{{ value }}</option>
              </select>
              <field-messages name="retirementType" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">退休时人员类别不能为空</div>
                <div slot="pattern" class="errorMessage">退休时人员类别不能为空</div>
              </field-messages>
            </div>
          </validate>


          <validate tag="div" class="form_group clearfix">
            <label class="control_label ">职业年金储存额</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.newMethod.profession_account_storage" disabled="disabled"
                     name="profession_account_storage" type="text"/>元
            </div>
          </validate>
          <!--<validate tag="div" class="form_group clearfix">-->
          <!--<label class="control_label "><em>*</em>实际缴费指数</label>-->
          <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input" v-model="params.newMethod.actual_average_payment_index" required name="averagePaymentIndex" type="text" />-->
          <!--<field-messages name="averagePaymentIndex" show="$dirty || $touched || $submitted">-->
          <!--<div slot="required" class="errorMessage">实际缴费指数不能为空</div>-->
          <!--</field-messages>-->
          <!--</div>-->
          <!--</validate>-->
          <!--<validate tag="div" class="form_group clearfix">-->
          <!--<label class="control_label "><em>*</em>上年度在岗平均工资</label>-->
          <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input" v-model="params.newMethod.average_wage_lastyear" required name="averageWageLastyear" type="text" />-->
          <!--<field-messages name="averageWageLastyear" show="$dirty || $touched || $submitted">-->
          <!--<div slot="required" class="errorMessage">上年度在岗平均工资不能为空</div>-->
          <!--</field-messages>-->
          <!--</div>-->
          <!--</validate>-->
        </div>
        <div class="fill_group_row clearfix fr w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>个人账户储存额</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.newMethod.personal_account_storage" required
                     name="personalAccountStorage" type="number"/>元
              <field-messages name="personalAccountStorage" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">个人账户储存额不能为空</div>
              </field-messages>
            </div>
          </validate>

          <!--<validate tag="div" class="form_group clearfix">-->
          <!--<label class="control_label "><em>*</em>计发月数</label>-->
          <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input" v-model="params.newMethod.months" required name="months" type="number" />-->
          <!--<field-messages name="months" show="$dirty || $touched || $submitted">-->
          <!--<div slot="required" class="errorMessage">计发月数不能为空</div>-->
          <!--</field-messages>-->
          <!--</div>-->
          <!--</validate>-->
        </div>
      </div>
      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>新老对比信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <div class="form_group clearfix">
            <label class="control_label ">核定养老金</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.contrast.approved_pension" type="number"/>
            </div>
          </div>
          <div class="form_group clearfix">
            <label class="control_label ">补扣发总月数</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.contrast.months" type="number"/>
            </div>
          </div>
          <div class="form_group clearfix">
            <label class="control_label ">平均每月补扣发</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.contrast.average_account" type="number"/>
            </div>
          </div>
        </div>
        <div class="fill_group_row clearfix fr w_half">
          <div class="form_group clearfix">
            <label class="control_label ">实发养老金</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.contrast.real_pension" type="number"/>
            </div>
          </div>
          <div class="form_group clearfix">
            <label class="control_label ">补扣发总金额</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.contrast.account" type="number"/>
            </div>
          </div>
          <div class="form_group clearfix">
            <label class="control_label "></label>
          </div>
        </div>
      </div>

      <!--标题-->
      <h3 class="form_title clearfix"><span>| </span>银行账户信息
      </h3>
      <!-- 标题 end-->
      <div class="clearfix">
        <div class="fill_group_row clearfix fl w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>发放银行</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" required v-model="params.bank.issuing_bank" name="issuing_bank"
                     type="text"/>
              <field-messages name="issuing_bank" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">发放银行不能为空</div>
              </field-messages>
            </div>
          </validate>
          <div tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>开户名</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.bank.bank_username" disabled="disabled" type="text"/>
              <!--<field-messages name="issuing_bank" show="$dirty || $touched || $submitted">-->
              <!--<div slot="required" class="errorMessage">开户名不能为空</div>-->
              <!--</field-messages>-->
            </div>
            <!---->
          </div>
          <!--<div class="form_group clearfix">-->
          <!--<label class="control_label ">开户行名称</label>-->
          <!--<div class="form_control w_auto ">-->
          <!--<input class="i_w300 form_input" v-model="params.bank.bank_name" type="text" />-->
          <!--</div>-->
          <!--</div>-->
        </div>
        <div class="fill_group_row clearfix fr w_half">
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>银行账号</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.bank.bank_account" required name="bank_account"
                     type="text"/>
              <field-messages name="bank_account" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">银行账号不能为空</div>
              </field-messages>
            </div>
          </validate>
          <validate tag="div" class="form_group clearfix">
            <label class="control_label "><em>*</em>开户行行号</label>
            <div class="form_control w_auto ">
              <input class="i_w300 form_input" v-model="params.bank.bank_number" required name="bankNumber"
                     type="number"/>
              <field-messages name="bankNumber" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">开户行行号不能为空</div>
              </field-messages>
            </div>
          </validate>
        </div>
      </div>
    </vue-form>

    <msgTips v-show="showFlagRetire" @confirm="layerConfirm" @cancel="layerCancel" title="提示">
      <p class="layer_content">退出编辑后【{{ params.user.username }}】依然为在职人员，确定退出？</p>
    </msgTips>
    <msgTips v-show="showFlag" @confirm="layerConfirm" @cancel="layerCancel" title="提示">
      <p class="layer_content">退出编辑后将不会保留新编辑内容，确定退出？</p>
    </msgTips>

    <div v-show="showRetire">
      <div class="msg_shade"></div>
      <div class="msg_box">
        <h3 class="title">提示</h3>
        <p class="layer_content">累计缴费年限小于15年不允许办理退休</p>
        <div class="salerMaskbtnBox">
          <button class="btn btn_blue" @click="confirmRetire">确定</button>
        </div>
      </div>
    </div>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>
</template>
<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import locations from '../../libs/location_libs'
import axios from 'axios'
import qs from 'qs'
import msgTips from '../../components/layer/msgTips'
import toastTips from '../../components/layer/toastTips'
import moment from 'moment'

export default {
  name: 'retireEdit',
  components: {
    VueDatepickerLocal,
    msgTips,
    toastTips
  },
  data() {
    return {
      tableTittles1: ['待遇项目', '金额', '开始年月', '操作'],
      tableTittles2: ['费款所属期', '支付金额', '个人账户支付金额', '操作'],
      areas: {
        allArr: locations.locations,
        domicileCities: '',
        addressDistrict: '',
        domicileDistrict: '',
        addressCities: ''
      },
      report_province: '',
      report_city: '',
      report_area: '',
      showFlag: false,
      showRetire: false,
      toastContent: '',
      showFlagRetire: false,
      turnDry: false,
      toast: false,
      formstate: {},
      companyData: [],
      positionArmy: [],
      techRank: [],

      id: this.$route.params.id,
      positionInfo1: {},
      positionInfo2: {},
      positionInfo3: {},

      realAge: '',
      viewAge: '',

      params: {
        id: this.$route.params.id,
        type: 2,
        user: {
          username: '',
          idcard: '',
          type: '',
          sex: 1,
          birthday: '',
          work_time: '',
          mobile: '',
          telephone: '',
          domicile_province: '',
          domicile_city: '',
          domicile_district: '',
          domicile_detail: '',
          company_id: 0,
          work_unit_name: '',
          address_province: '',
          address_city: '',
          address_district: '',
          address_detail: '',
          postal_code: '',
          social_security_account: ''
        },
        special: {
          type: 0,
          position_id: 0,
          basic_wage: '',
          retirement_allowance: '',
          extra_allowance: '',
          salary_level: ''
        },
        insurance: {
          insured_time: '',
          first_insured_time: '',
          compilation_type: 1,
          account_creation_time: ''
        },
        period: {
          type: 0,
          transition: '',
          interim: false,
          position_change_last: 0,
          level_change_last: 1,
          basic_wage: 0,
          retirement_allowance: '',
          increased_retirement_fee: '',
          position_change_time: '',
          salary_level: '',
          position_change_basic_wage: '',
        },
        oldMethod: {
          military_cadres: 0,
          military_position: '',
          military_rank: '',
          military_revolution_time: '',
          old_method_pension: '',
          proportion: '0.70',
          rate: ''
        },
        newMethod: {
          retirement_type: 0,
          contribution_index: '',
          actual_average_payment_index: '',
          average_payment_index: '',
          average_wage_lastyear: '',
          personal_account_storage: '',
          profession_account_storage: '',
          months: '',
          new_method_pension: '',
          basic_pension: '',
        },
        contrast: {
          over_new_method_pension: '',
          proportion: '',
          amount: '',
          approved_pension: '',
          real_pension: '',
          months: '',
          account: '',
          average_account: ''
        },
        bank: {
          issuing_bank: '',
          bank_account: '',
          bank_username: '',
          bank_number: '',
          bank_name: ''
        },

        retirement: {
          change_type: 1,
          retirement_type: 0,
          rank: '',
          position_id: 0,
          date: '',
          treatment_start_time: '',
          reissue_start_time: '',
          payment_years: '',
          payment_months: '',
          actual_payment_years: '1',
          accumulated_payment_years: '',
          accumulated_payment_months: '',
          actual_payment_months: '',
          salary_level: '',
          type: 0,
          retirement_allowance: ''
        }
      },
      retiredType: {},
      personnelType: {},
      isSave: true
    }
  },
  mounted: function () {
    var that = this;
    axios.get('/admin/company/list', {}).then((response) => {
      if (response.data.code == 22000) {
        that.companyData = response.data.result.list;
      } else if (response.data.code == 50001) {
        window.location.href = '/#/login'
      } else {
        that.toast = true;
        that.toastContent = response.data.message;
        setTimeout(function () {
          that.toast = false;
          that.toastContent = '';
        }, 3000)
      }
    });

    that.params.retirement.treatment_start_time = moment(that.params.retirement.treatment_start_time).format("YYYY-MM-DD")

    if (that.id > 0) {
      axios.get('/user/getInfo', {
        params: {
          id: that.id
        }
      }).then((response) => {
        if (response.data.code == 22000) {
          var result = response.data.result;
          for (var key in result) {
            for (var item in result[key]) {
              if (typeof (result[key][item]) == 'string' && result[key][item].indexOf('-') > 0
                && result[key][item].split('-')[0] == '0000') {
                result[key][item] = '';
              }
            }
          }
          console.log(that.params)
          that.params = result;
          if (that.$route.query.isFromWorker) {
            this.getDays('2014-9-30', this.params.user.work_time);
          }
          that.params.bank.bank_username = result.user.username;
          //判断过渡期是否显示隐藏
          if (that.params.period.transition == 1) {
            // that.params.period.interim = true;
            this.$set(that.params.period, "interim", true)
          } else {
            // that.params.period.interim = false;
            this.$set(that.params.period, "interim", false)
          }

          let userSex = result.user.social_security_account
          if (parseInt(userSex.substr(16, 1)) % 2 == 1) {
            that.params.user.sex = 1
          } else {
            that.params.user.sex = 2
          }
        } else if (response.data.code == 50001) {
          window.location.href = '/#/login';
        }
      })
    }

    function retiredType() {
      return axios.get('/config/getRetirementType');
    }

    function getPersonnelType() {
      return axios.get('/config/getPersonnelType');
    }

    axios.all([retiredType(), getPersonnelType()])
      .then(axios.spread(function (retiredType, personnelType) {
        if (retiredType.data.code == 22000) {
          that.retiredType = retiredType.data.result;
        } else if (retiredType.data.code == 50001) {
          window.location.href = '/#/login';
        }
        if (personnelType.data.code == 22000) {
          that.personnelType = personnelType.data.result;
        } else if (personnelType.data.code == 50001) {
          window.location.href = '/#/login';
        }
      }));

    axios.get('/config/getArmyPosition', {}).then((response) => {
      if (response.data.code == 22000) {
        that.positionArmy = response.data.result;
      } else if (response.data.code !== 22000) {
        console.log(response.data.message)
      }
    });

    axios.get('/config/getTechRank', {}).then((response) => {
      if (response.data.code == 22000) {
        that.techRank = response.data.result;
      } else if (response.data.code !== 22000) {
        console.log(response.data.message)
      }
    });
    that.getPersonAccount();
  },
  created: function () {
    this.$router.beforeEach((to, from, next) => {
      if (this.$route.path == '/add/retire/1/edit/-1' && this.isSave) {
        const answer = window.confirm('当前页面处于编辑状态确认要退出？');
        if (answer) {
          next()
        } else {
          next(false)
        }
      } else {
        next();
      }

    })
  },
  methods: {
    updateCity: function (cities, province) {
      this.areas[cities] = this.areas.allArr[province].sub
    },
    updateDistrict: function (district, cities, province) {
      this.areas[district] = this.areas.allArr[province].sub[cities].sub
    },
    getScale: function () {
      var that = this;

      if (that.params.retirement.accumulated_payment_years) {
        axios.get('/config/getAccount', {
          params: {
            accumulated_payment_years: that.params.retirement.accumulated_payment_years
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.oldMethod.proportion = response.data.result.account

          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }
    },
    getDays: function (strDateStart, strDate) {

      let strDateEnd = moment(strDate).format("YYYY-MM-DD");
      let _this = this;
      let strSeparator = "-"; //日期分隔符
      let oDate1;
      let oDate2;

      oDate1 = strDateStart.split(strSeparator);
      oDate2 = strDateEnd.split(strSeparator);

      // let strDateS = new Date(oDate1[0], oDate1[1]-1, oDate1[2]);
      // let strDateE = new Date(oDate2[0], oDate2[1]-1, oDate2[2]);
      //
      // viewDay = parseInt(Math.abs(strDateS - strDateE ) / 1000 / 60 / 60 /24)//把相差的毫秒数转换为天数
      // this.realAge = viewDay
      //
      // if(viewDay<30){
      //   _this.$set(_this.params.retirement,"payment_months",1)
      //   _this.$set(_this.params.retirement,"payment_years",0)
      //
      // }
      // if(viewDay>=30 && viewDay<=365 ){
      //   _this.$set(_this.params.retirement,"payment_months",parseInt(viewDay%365/30))
      //   _this.$set(_this.params.retirement,"payment_years",0)
      // }
      // if(viewDay>365 && parseInt(viewDay%365/30)<12 ){
      //   _this.$set(_this.params.retirement,"payment_years",parseInt(viewDay/365))
      //   _this.$set(_this.params.retirement,"payment_months" ,parseInt(viewDay%365/30))
      // }

      if (oDate2[1] <= 9) {
        _this.$set(_this.params.retirement, "payment_months", Number(oDate1[1]) - Number(oDate2[1]) + Number('1'))
        _this.$set(_this.params.retirement, "payment_years", Number(oDate1[0]) - Number(oDate2[0]))
      } else {
        _this.$set(_this.params.retirement, "payment_months", Number(oDate1[1]) - Number(oDate2[1]) + Number('13'))
        _this.$set(_this.params.retirement, "payment_years", Number(oDate1[0]) - Number(oDate2[0]) - Number('1'))
      }
    },
    getRealit: function (strDate, strDateEnd) {
      let strDateStart = moment(strDate).format("YYYY-MM-DD")
      let _this = this;
      let strSeparator = "-"; //日期分隔符
      let oDate1;
      let oDate2;
      let viewDay2;

      let realitDay = '';

      oDate1 = strDateStart.split(strSeparator);
      oDate2 = strDateEnd.split(strSeparator);

      // let strDateS = new Date(oDate1[0], oDate1[1]-1, oDate1[2]);
      // let strDateE = new Date(oDate2[0], oDate2[1]-1, oDate2[2]);
      //
      // viewDay2 = parseInt(Math.abs(strDateS - strDateE ) / 1000 / 60 / 60 /24)//把相差的毫秒数转换为天数
      // this.viewAge = viewDay2
      // if(viewDay2<30 ){
      //   _this.$set(_this.params.retirement,"actual_payment_months",1)
      //   _this.$set(_this.params.retirement,"actual_payment_years",0)
      // }
      // if(viewDay2>=30 && viewDay2<=365){
      //   _this.$set(_this.params.retirement,"actual_payment_months",parseInt(viewDay2%365/30))
      //   _this.$set(_this.params.retirement,"actual_payment_years",0)
      // }
      // if(viewDay2>365 && parseInt(viewDay2%365/30)<12){
      //   _this.$set(_this.params.retirement,"actual_payment_months",parseInt(viewDay2%365/30))
      //   _this.$set(_this.params.retirement,"actual_payment_years",parseInt(viewDay2/365))
      // }

      if (oDate1[1] >= 10) {
        _this.$set(_this.params.retirement, "actual_payment_months", Number(oDate1[1]) - Number(oDate2[1]))
        _this.$set(_this.params.retirement, "actual_payment_years", Number(oDate1[0]) - Number(oDate2[0]))
      } else {
        _this.$set(_this.params.retirement, "actual_payment_months", Number(oDate1[1]) - Number(oDate2[1]) + Number('12'))
        _this.$set(_this.params.retirement, "actual_payment_years", Number(oDate1[0]) - Number(oDate2[0]) - Number('1'))
      }
    },

    //改革时退休补贴
    getAllowan: function () {
      let that = this;
      if (that.params.special.position_id) {
        axios.get('/config/getSubsidy', {
          params: {
            id: that.params.special.position_id
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.special.retirement_allowance = response.data.result.subsidy_standard;
          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }

    },

    //是否有过渡期退休补贴
    getPeriodAllowan: function () {
      let that = this;
      if (that.params.period.position_change_last) {
        axios.get('/config/getSubsidy', {
          params: {
            id: that.params.period.position_change_last
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.period.retirement_allowance = response.data.result.subsidy_standard;
          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }

    },

    //退休信息退休补贴
    getRetireAllowan: function () {
      let that = this;
      if (that.params.retirement.position_id) {
        axios.get('/config/getSubsidy', {
          params: {
            id: that.params.retirement.position_id
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.retirement.retirement_allowance = response.data.result.subsidy_standard;
          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }

    },

    //获取增资
    getCapital: function () {
      let that = this;
      if (that.params.retirement.position_id) {
        axios.get('/config/getIncrease', {
          params: {
            id: that.params.retirement.position_id
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.special.extra_allowance = response.data.result.increase_standard
          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }
    },
    //基本工资
    getBasepay: function () {
      let that = this;
      if (that.params.special.position_id && that.params.special.salary_level) {
        axios.get('/config/getWage', {
          params: {
            position_id: that.params.special.position_id,
            salary_rank: that.params.special.salary_level
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.special.basic_wage = response.data.result.wage_standard
          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }
    },
    //获取升降后职务对应的2014年9月基本工资标准
    getPostpay: function () {
      let that = this;
      if (that.params.period.position_change_last && that.params.period.salary_level) {
        axios.get('/config/getWage', {
          params: {
            position_id: that.params.period.position_change_last,
            salary_rank: that.params.period.salary_level
          }
        }).then((response) => {
          console.log(response)
          if (response.data.code == 22000) {
            that.params.period.position_change_basic_wage = response.data.result.wage_standard
          } else if (response.data.code == 22001) {
            console.log(response.data.message)
          }
        })
      }
    },
    //获取个人账户储存额
    getPersonAccount: function () {
      let that = this;
      axios.get('/config/getPersonAccount', {
        params: {
          user_id: that.id,
        }
      }).then((response) => {
        if (response.data.code == 22000) {
          that.params.newMethod.personal_account_storage = response.data.result.account
        } else if (response.data.code == 22001) {
          console.log(response.data.message)
        }
      })
    },

    getTotal: function () {
      let _this = this;
      if (typeof (this.params.retirement.payment_months) != "undefined" && typeof (this.params.retirement.actual_payment_months) != "undefined" && typeof (this.params.retirement.payment_years) != "undefined" && typeof (this.params.retirement.actual_payment_years) != "undefined") {

        let pm = Number(this.params.retirement.payment_months);
        let py = Number(this.params.retirement.payment_years);
        let apm = Number(this.params.retirement.actual_payment_months);
        let apy = Number(this.params.retirement.actual_payment_years);

        let m_total = apy * 12 + apm + py * 12 + pm;

        _this.$set(_this.params.retirement, "accumulated_payment_months", m_total % 12)
        _this.$set(_this.params.retirement, "accumulated_payment_years", parseInt(m_total / 12))

        if (_this.params.retirement.accumulated_payment_years < 15) {
          let that = this;
          that.showRetire = true;
        }
      }

    },
    confirmRetire: function () {
      window.location.href = '/#/list/0';
    },

    save: function () {
      var that = this;
      var tipBox = document.getElementsByClassName('tipsBox')[0];

      that.params.retirement.date = moment(that.params.retirement.date).format("YYYY-MM-DD")
      that.params.retirement.treatment_start_time = moment(that.params.retirement.treatment_start_time).format("YYYY-MM-DD")
      that.params.retirement.reissue_start_time = moment(that.params.retirement.reissue_start_time).format("YYYY-MM-DD")
      that.params.user.work_time = moment(that.params.user.work_time).format("YYYY-MM-DD")
      that.params.user.birthday = moment(that.params.user.birthday).format("YYYY-MM-DD")
      that.params.period.position_change_time = moment(that.params.period.position_change_time).format("YYYY-MM-DD")

      if (!that.formstate.$invalid) {
        if (that.params.period.transition == 2) {
          that.params.period.type = 0
          that.params.period.position_change_last = 0
          that.params.period.position_change_basic_wage = ''
          that.params.period.position_change_time = '0000-00-00'
          that.params.period.salary_level = ''
          that.params.period.retirement_allowance = ''
        }

        if (that.params.oldMethod.military_cadres == 2) {
          that.params.oldMethod.military_revolution_time = '0000-00-00'
          that.params.oldMethod.military_position = 0
          that.params.oldMethod.military_rank = 0
        }

        if (that.$route.query.isFromWorker) {
          axios.post('/user/becomeRetired', qs.stringify(
            that.params
          )).then((response) => {
            if (response.data.code == 22000) {
              this.isSave = false;
              that.toastContent = '保存成功';
              tipBox.style.display = 'block';
              setTimeout(function () {
                tipBox.style.display = 'none';
                window.location.href = '/#/add/retire/1/see/' + that.id;
                window.location.reload();
              }, 3000);
            } else if (response.data.code == 50001) {
              this.isSave = false;
              window.location.href = '/#/login';
            } else {
              this.isSave = true;
              that.toastContent = response.data.message;
              tipBox.style.display = 'block';
              setTimeout(function () {
                tipBox.style.display = 'none';
              }, 3000);
            }
          })
        } else {
          if (that.id > 0) {
            that.params['id'] = that.id;
            axios.post('/user/update', that.params).then((response) => {
              if (response.data.code == 22000) {
                this.isSave = false;
                that.toastContent = '修改成功';
                tipBox.style.display = 'block';
                setTimeout(function () {
                  tipBox.style.display = 'none';
                  window.location.href = '/#/add/retire/1/see/' + that.id;
                  window.location.reload();
                }, 3000);
              } else if (response.data.code == 50001) {
                this.isSave = false;
                window.location.href = '/#/login';
              } else {
                this.isSave = true;
                that.toastContent = response.data.message;
                tipBox.style.display = 'block';
                setTimeout(function () {
                  tipBox.style.display = 'none';
                }, 3000);
              }
            })
          } else {
            axios.post('/user/create', that.params).then((response) => {
              if (response.data.code == 22000) {
                this.isSave = false;
                that.toastContent = '保存成功';
                tipBox.style.display = 'block';
                setTimeout(function () {
                  tipBox.style.display = 'none';
                  window.location.href = '/#/add/retire/1/see/' + response.data.result.id;
                  window.location.reload();
                }, 3000);
              } else if (response.data.code == 50001) {
                this.isSave = false;
                window.location.href = '/#/login';
              } else {
                this.isSave = true;
                that.toastContent = response.data.message;
                tipBox.style.display = 'block';
                setTimeout(function () {
                  tipBox.style.display = 'none';
                }, 3000);
              }
            })
          }
        }
      } else {
        that.formstate._submit();
      }
    },
    cancel: function () {
      this.isSave = false;
      var that = this;
      if (!that.$route.query.isFromWorker) {
        that.showFlag = true;
      } else {
        that.showFlagRetire = true;
      }
    },

    changeInterim: function () {
      var that = this;
      if (that.params.period.transition == 1) {
        // that.params.period.interim = true;
        this.$set(that.params.period, "interim", true)
      } else {
        // that.params.period.interim = false;
        this.$set(that.params.period, "interim", false)
      }
    },

    changeRetiret: function () {
      let that = this;
      this.$set(that.params.retirement, "treatment_start_time", moment(that.params.retirement.date).add(1, 'months').format("YYYY-MM-DD"))
      this.$set(that.params.retirement, "reissue_start_time", moment(that.params.retirement.treatment_start_time).format("YYYY-MM-DD"))
      that.getRealit(this.params.retirement.date, '2014-9-1');
      that.getTotal();
      that.getScale();
    },
    changeReissue: function () {
      let that = this;
      this.$set(that.params.retirement, "reissue_start_time", moment(that.params.retirement.treatment_start_time).format("YYYY-MM-DD"))
      console.log('补发时间')
    },

    layerConfirm: function () {
      var that = this;
      if (!that.$route.query.isFromWorker) {
        that.showFlag = false;
        if (that.id > 0) {
          window.location.href = '/#/add/retire/1/see/' + that.id;
        } else {
          window.location.href = '/#/list/1';
        }
      } else {
        that.showFlagRetire = false;
        window.location.href = '/#/add/worker/0/see/' + that.id;
      }
      window.location.reload();
    },
    layerCancel: function () {
      this.isSave = true;
      var that = this;
      if (!that.$route.query.isFromWorker) {
        that.showFlag = false;
      } else {
        that.showFlagRetire = false;
      }
    },

    getPositionInfo: function (type, step) {
      var that = this;
      axios.get('/config/getPersonnelTypeRank',
        {params: {type: type}}
      ).then((response) => {
        if (response.data.code == 22000) {
          if (step == 'special') {
            that.positionInfo1 = response.data.result;
          } else if (step == 'retirement') {
            that.positionInfo2 = response.data.result;
          } else if (step == 'period') {
            that.positionInfo3 = response.data.result;
          }
        } else if (response.data.code == 50001) {
          window.location.href = '/#/login'
        }
      })
    },
    takeBirthday: function () {
      if (this.params.user.social_security_account)
        this.params.user.birthday = this.params.user.social_security_account.substr(6, 4) + '-' + this.params.user.social_security_account.substr(10, 2) + '-' + this.params.user.social_security_account.substr(12, 2)
    },
    //  失去焦点
    changeWorkTime: function () {
      this.getDays('2014-9-30', this.params.user.work_time);
      this.getTotal();
      this.getScale();
    },


  },
  watch: {
    'params.user.domicile_province': function () {
      this.updateCity('domicileCities', this.params.user.domicile_province);
    },
    'params.user.address_province': function () {
      this.updateCity('addressCities', this.params.user.address_province);
    },
    'params.user.domicile_city': function () {
      this.updateDistrict('domicileDistrict', this.params.user.domicile_city, this.params.user.domicile_province);

    },
    'params.user.address_city': function () {
      this.updateDistrict('addressDistrict', this.params.user.address_city, this.params.user.address_province);
    },
    'params.special.type': function () {
      this.getPositionInfo(this.params.special.type, 'special')
    },
    'params.retirement.rank': function () {
      this.getPositionInfo(this.params.retirement.rank, 'retirement')
    },
    'params.period.type': function () {
      this.getPositionInfo(this.params.period.type, 'period')
    },

    'params.special.position_id': function () {
      this.getAllowan();
      this.getBasepay();
    },
    'params.period.position_change_last': function () {
      this.getPeriodAllowan();
      this.getPostpay();
    },
    'params.retirement.position_id': function () {
      this.getRetireAllowan();
      this.getCapital();
    },
    'params.special.salary_level': function () {
      this.getBasepay();
    },
    'params.oldMethod.military_cadres': function () {
      if (this.params.oldMethod.military_cadres == 1) {
        this.turnDry = true
      } else {
        this.turnDry = false
      }
    },
    'params.period.salary_level': function () {
      this.getPostpay();
    }
  }

}
</script>
<style lang="less" scoped>
.tip_bar {
  line-height: 20px;

  .question_logo {
    display: inline-block;
    text-align: center;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 50%;
    color: #e1e7f6;
    border: 1px solid #e1e7f6;
    margin-right: 10px;
  }
}

.w_375 {
  width: 375px !important;;
}

.w100 {
  width: 85% !important;
}

.flex {
  display: flex;
  width: 90%;
}

.auto_flex {
  flex: .94;
}

.table_outer_box {
  margin-bottom: 30px;
}

.history_info_box {
  position: relative;

  .line_box {
    position: absolute;
    left: 91px;
    height: 100%;
    border-right: 1px solid #e1e7f6;
  }

  .history_info {
    /*padding-left: 39px;*/
    margin-bottom: 40px;

    .history_left {
      float: left;
      width: auto;
      text-align: right;
    }

    .history_right {
      float: left;
      margin-left: 50px;

      p {
        color: #32363a;

        span {
          color: #32363a;
        }

        .edition_change_info {
          margin-left: 10px;
          color: #aaa;
        }
      }

      .history_info_tit {
        position: relative;
        margin-bottom: 10px;

        .blue_dot {
          position: absolute;
          top: 9px;
          left: -6px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #0080ea;
        }
      }
    }
  }
}

.date_picker_out {
  padding: 0 !important;

  input {
    border: none !important;
    width: 100% !important;
  }
}

.shiftHide {
  display: none;
}

.shiftShow {
  display: block;
}

.operation_list {
  position: absolute;
  right: 20px;
  top: 0;

  li {
    cursor: pointer;
    padding-left: 30px;
    margin-left: 22px;
    line-height: 50px;
  }
}

.layer_content {
  text-align: center;
  line-height: 80px;
  font-size: 16px;
}

.msg_shade {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  z-index: 999;
}

.msg_box {
  padding: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -158px;
  margin-top: -114px;
  border: 1px solid #fff;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 1px 1px 50px rgba(0, 0, 0, .3);
  z-index: 1000;
  box-sizing: border-box;

  h3 {
    font-weight: normal;
    padding-bottom: 20px;
    color: #32363a;
    font-size: 16px;
  }

  .salerMaskbtnBox {
    margin-top: 32px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editList/retireEdit.vue